import React, { useCallback } from 'react';
import { ButtonsWrapper, Wrapper } from './styled';

const NumberInput = ({ onChange, value, min, max, ...rest }) => {
  const onValueChange = useCallback(
    (newValue) => {
      onChange?.(newValue);
    },
    [onChange]
  );
  const onInputChange = useCallback(
    ({ target: { value: newValue } }) => {
      onValueChange(newValue);
    },
    [onValueChange]
  );

  const increaseValue = useCallback(() => {
    if (value >= max) {
      return;
    }
    onValueChange(value + 1);
  }, [max, onValueChange, value]);

  const decreaseValue = useCallback(() => {
    if (value <= min) {
      return;
    }
    onValueChange(value - 1);
  }, [min, onValueChange, value]);

  return (
    <Wrapper className="wrapper">
      <input type="number" value={value} min={min} max={max} {...rest} onChange={onInputChange} />
      <ButtonsWrapper>
        <div className="wrapper-button wrapper-up" onClick={increaseValue}>
          +
        </div>
        <div className="wrapper-button wrapper-down" onClick={decreaseValue}>
          -
        </div>
      </ButtonsWrapper>
    </Wrapper>
  );
};

export default NumberInput;
